export default __webpack_public_path__ + "static/media/remo7.9054c238.jpg";